import IconProps from 'packages/kakapo-ui-kit/assets/icons/IconProps';

function PlusIcon(props: IconProps) {
	const { color = 'white' } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
			<rect x="9" y="5" width="2" height="10" fill={color} />
			<rect x="5" y="9" width="10" height="2" fill={color} />
		</svg>
	);
}

export default PlusIcon;
